module.exports = __webpack_public_path__ + "static/media/ios-person.4daea7b9.svg";